export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Message inbox",
    subtitle: "WhatsApp, web concierge and OTA in one place",
  },

  channels: {
    all: "All",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "No new messages",
    description: "New bot messages will appear here when they arrive",
  },

  buttons: {
    markAll: "Mark all as read",
    goToChat: "Configure AI Agent",
    archive: "Archive conversation",
  },

  actions: {
    replyWhatsApp: "Reply on WhatsApp",
  },

  time: {
    now: "Now",
    minuteSuffix: "m",
    hourSuffix: "h",
    daySuffix: "d",
    today: "Today",
    yesterday: "Yesterday",
  },

  questions: {
    searchPlaceholder: "Search questions...",
    answered: "Answered",
    noAnswer: "Pending",
    withImage: "With image",
    empty: "No questions found",
    confirmDelete: "Are you sure you want to delete this question?",
  },

  answer: {
    assistantResponse: "Assistant response",
    attachedImageOptional: "Attached image (optional)",
    uploadImage: "Upload image",
    clickToSelect: "Click to select an image",
    changeImage: "Change image",
    imagePreviewAlt: "Image preview",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "online",
    today: "Today",
    exampleQuestion: "Example question",
    writeAnswerPlaceholder: "Write an answer for this question...",
    writeMessagePlaceholder: "Type a message...",
    answerImageAlt: "Answer image",
    confirmDeleteImage: "Delete image?",
    imageDeletedSuccess: "Image deleted successfully.",
    virtualAssistant: "Virtual Assistant",
  },

  search: {
    placeholder: "Search by name, phone or reservation code...",
    noResultsTitle: "No conversations found",
    noResultsDescription:
      "Try another name, phone number or reservation code.",
  },

  archive: {
    title: "Archive conversation",
    message:
      "If you archive this conversation it will disappear from this list. You can still access it from the linked reservation.",
    cancel: "Cancel",
    confirm: "Archive",
  },
};

export default bot;
